import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import { updateExtraByName } from 'apps/auth/actions/extraAction';
import { changeFormFieldValue, removeFieldError } from 'apps/auth/actions/formAction';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import InputAutoDetect from 'apps/auth/components/form/InputAutoDetect';
import NewCardField from 'apps/auth/components/form/NewCardField';
import AntifraudCommunicationsTermsModal from 'apps/auth/components/send/disclaimers/AntifraudCommunicationsTermsModal';
import FieldErrorPopup from 'apps/auth/components/send/popups/errors/FieldErrorPopup';
import { SENDER_ADDITIONAL_INFO_SCREEN } from 'apps/auth/components/send/SendConstants';
import ModalNew from 'apps/auth/components/utils/ModalNew';
import { ADDITIONAL_SENDER_INFO_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { SEND_FROM } from 'apps/auth/constants/Constants';
import { FROM_ACCOUNT, SOURCE_CARD_CVV, SOURCE_CARD_EXP_DATE } from 'apps/auth/constants/fieldsName';
import { PAN } from 'apps/auth/constants/FieldType';
import { ERR_REJECT_ALL_AFT_DETECTED } from 'apps/auth/constants/WellKnownErrorCodes';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const GTFromFields = ({ showPaymentFields = true, showFromFields = true, ...props }) => {
    const popupRef = useRef(null);
    const modalRef = useRef(null);

    const {
        senderDetails,
        providerHeader,
        senderSubInfo,
        senderExtraScreenSubInfo,
        cardsAddBankCardText,
        addBankAccountSubText,
        paymentFromCardRejectedPopupText,
        buttonCardsAddOther,
        changePaymentOption,
        antiFraudDisclaimerTitle,
    } = usePageMessages();
    const { toCountry, sendFlowV3, fromCountry, hasOtherPaymentOption, antiFraudDisclaimer } = useExtra();

    const type = props.fields.find((f) => f.name === FROM_ACCOUNT)?.type;

    const getTitleText = (showPaymentFields, showFromFields) => (!showPaymentFields && showFromFields ? providerHeader : senderDetails);

    const getSubTitleText = (showPaymentFields, showFromFields) => {
        if (showPaymentFields && type === PAN) {
            return cardsAddBankCardText;
        } else if (showPaymentFields && !!type) {
            return addBankAccountSubText;
        }
        return !showPaymentFields && showFromFields ? senderExtraScreenSubInfo : senderSubInfo;
    };

    useEffect(() => {
        if (__isBrowser__) {
            if (props.screen === SENDER_ADDITIONAL_INFO_SCREEN) {
                props.sendAmplitudeEventOnRender?.(ADDITIONAL_SENDER_INFO_SHOWN);
            }
        }
    }, []);

    const panHintButtonClick = (errorCode, secondaryButtonClick) => {
        if (errorCode === ERR_REJECT_ALL_AFT_DETECTED) {
            popupRef.current?.open(
                <FieldErrorPopup text={<DangerouslyHtml dangerouslyHtml={paymentFromCardRejectedPopupText} />} popupRef={popupRef}>
                    <PopupButton
                        iconName="plus"
                        text={buttonCardsAddOther}
                        onClick={() => {
                            props.updateExtraByName(props.binInfoExtraName, null);
                            props.changeFormFieldValue(props.formName, null, FROM_ACCOUNT);
                            props.removeFieldError(props.formName, FROM_ACCOUNT);
                            popupRef.current?.close();
                        }}
                    />
                    {hasOtherPaymentOption && (
                        <PopupButton
                            iconName="arrow-forward"
                            text={changePaymentOption}
                            onClick={() => {
                                secondaryButtonClick();
                                popupRef.current?.close();
                            }}
                        />
                    )}
                </FieldErrorPopup>,
            );
        }
    };

    return (
        <>
            <HeaderPanel
                subtitle={getSubTitleText(showPaymentFields, showFromFields)}
                title={getTitleText(showPaymentFields, showFromFields)}
                buttonRowType="link"
                buttonRowCaption={props.screen === SENDER_ADDITIONAL_INFO_SCREEN ? antiFraudDisclaimerTitle : ''}
                buttonRowOnClick={(e) => {
                    e.preventDefault();
                    modalRef.current?.open(<AntifraudCommunicationsTermsModal content={antiFraudDisclaimer} modalRef={modalRef} />);
                }}
            />
            {showPaymentFields && type === PAN && (
                <Row indent="16px">
                    <NewCardField
                        canShowUsaCardComment={true}
                        isClearErrorByTyping={false}
                        showPaymentMethodScreen={props.showPaymentMethodScreen}
                        binExtraName="fromBinInfo"
                        actionType={SEND_FROM}
                        countryA2From={fromCountry?.code}
                        formName={props.formName}
                        panName={FROM_ACCOUNT}
                        expiredDateName={SOURCE_CARD_EXP_DATE}
                        cvvName={sendFlowV3 ? null : SOURCE_CARD_CVV}
                        hintButtonClick={panHintButtonClick}
                    />
                </Row>
            )}
            {showFromFields && (
                <>
                    {props.fields.map((field) => {
                        return (
                            <Row indent="24px" key={field.name}>
                                <InputAutoDetect formName={props.formName} defaultCountry={toCountry?.code} field={field} />
                            </Row>
                        );
                    })}
                </>
            )}
            <PopupNew ref={popupRef} />
            <ModalNew ref={modalRef} />
        </>
    );
};

export default connect(null, {
    changeFormFieldValue,
    removeFieldError,
    updateExtraByName,
})(GTFromFields);
